export default {
  talk_to_us: 'Sprechen Sie mit uns:',
  send_us_email: 'Senden Sie uns eine E-Mail:',
  visit_website: 'Besuchen Sie unsere Website:',
  join_our_community: 'Treten Sie unserer Gemeinschaft bei für exklusive Angebote und Updates!',
};
